import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './DropdownFilterWrapper.css';
import React, { useRef } from 'react';
import IconChevronDown from '../../../../../resources/icons/IconChevronDown.svg';
export var DropdownFilterWrapper = function DropdownFilterWrapper(_ref) {
  var children = _ref.children,
    defaultLabel = _ref.defaultLabel,
    label = _ref.label,
    resultsLabel = _ref.resultsLabel,
    showLabel = _ref.showLabel,
    applyFn = _ref.applyFn,
    open = _ref.open,
    setStartPage = _ref.setStartPage;
  var _open = _slicedToArray(open, 2),
    isOpen = _open[0],
    setisOpen = _open[1];
  var rootRef = useRef();
  var borderRadius = {
    borderRadius: '4px'
  };
  function handleClick(e) {
    if (e.target.closest('.filter__field') !== rootRef.current) {
      setisOpen(false);
    }
  }
  var _closeDropdwn = function closeDropdwn() {
    setisOpen(false);
    if (setStartPage) {
      setStartPage(false);
    }
    document.body.removeEventListener('click', _closeDropdwn);
  };
  var toggleFilter = function toggleFilter(e) {
    if (e.target.closest(".filter-panel__box")) {
      setisOpen(!isOpen);
      if (setStartPage) {
        setStartPage(isOpen);
      }
      if (isOpen) {
        document.body.removeEventListener('click', handleClick);
      } else {
        document.body.addEventListener('click', handleClick);
      }
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(commonStyles)
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter__field dropdown-filter-wrapper",
    ref: rootRef
  }, /*#__PURE__*/React.createElement("div", {
    onClick: toggleFilter,
    onKeyPress: function onKeyPress(event) {
      if (event.key === "Enter" || event.key === "NumpadEnter") {
        event.preventDefault();
        event.target.click();
      }
    },
    className: "filter-panel eloqua ".concat(isOpen ? 'filter-panel--open' : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: "body-small filter-panel__mob-label"
  }, defaultLabel), /*#__PURE__*/React.createElement("div", {
    tabIndex: 0,
    className: "filter-panel__box ".concat(isOpen ? 'filter-panel__box--openedDrop' : ''),
    style: !isOpen ? borderRadius : undefined
  }, /*#__PURE__*/React.createElement("span", {
    className: "filter-panel__trigger js-filter-panel__trigger"
  }, label), /*#__PURE__*/React.createElement("div", {
    className: "filter-panel__text body-small"
  }, label), /*#__PURE__*/React.createElement("img", {
    className: "icon",
    src: IconChevronDown,
    alt: "smth"
  })), isOpen && /*#__PURE__*/React.createElement("div", {
    className: "filter-panel__inner"
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter-panel__inner-scroll"
  }, children), /*#__PURE__*/React.createElement("div", {
    className: "filter-panel__bottom"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-primary js-btn-close-panel",
    onClick: function onClick() {
      return applyFn && applyFn(_closeDropdwn);
    }
  }, showLabel, " ", resultsLabel))))));
};
var commonStyles = "c1dottnm";